import { useState } from 'react';

const faqs = [
  {
    question: '韩漫网站是否需要注册才能阅读？',
    answer: '不需要！韩漫网站始终坚持免费开放的原则，所有漫画资源均可直接在线阅读，无需注册账号，无需任何付费，真正做到随时随地方便快捷地畅享韩漫阅读体验。',
  },
  {
    question: '什么是下拉式韩漫在线阅读？',
    answer: '下拉式韩漫在线阅读是一种专为手机和网页优化的阅读方式。您只需向下滑动页面，漫画内容就会连续不断地呈现，无需翻页，阅读体验流畅自然。这种阅读方式特别适合韩国漫画的长条式排版，让您沉浸在漫画世界中不受打扰。',
  },
  {
    question: '网站上的韩漫资源多久更新一次？',
    answer: '我们每天都会更新漫画资源，热门连载作品保持与韩国同步更新。您可以在首页的"每日更新"板块查看最新上架的漫画章节。一般来说，热门作品每天都会有新的章节上线，让您追更不等待。',
  },
  {
    question: '如何在手机上阅读韩漫？',
    answer: '韩漫网站完美适配移动端设备，您只需使用手机浏览器访问我们的网站，即可享受专门为手机优化的下拉式阅读体验。无论是iOS还是Android设备，都能流畅阅读。您还可以将网站添加到手机桌面，像使用App一样方便快捷。',
  },
  {
    question: '韩漫网站有哪些类型的漫画？',
    answer: '我们涵盖了丰富的漫画类型，包括恋爱、奇幻、动作、悬疑、搞笑、都市、穿越、耽美等8大分类。无论您喜欢浪漫的爱情故事，还是热血的战斗场面，亦或是烧脑的悬疑剧情，都能在这里找到心仪的作品。',
  },
  {
    question: '阅读漫画时遇到加载问题怎么办？',
    answer: '如果遇到加载缓慢的情况，建议您检查网络连接状态或尝试刷新页面。我们采用了先进的CDN加速技术，确保全国各地的用户都能享受流畅的阅读体验。如问题持续存在，可以通过"关于我们"页面的联系方式联系客服处理。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-400 mt-2">关于韩漫网站的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm font-medium text-foreground-800">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}